import { PropuestaSolicitud } from "@app/_models/propuestaSolicitud";

export function reflejaAprobado(element :PropuestaSolicitud){
  element.AplicaReinscripcionAprob = element.AplicaReinscripcion;
  element.AplicaInscripcionAprobada = element.AplicaInscripcion;
  if(!this.esRevision){
      element.BecaAprobada = element.BecaPropuesta;
  }
}